"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx5 = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _CaretLeftIcon = _interopRequireDefault(require("../_icons/CaretLeftIcon"));
var _CaretRightIcon = _interopRequireDefault(require("../_icons/CaretRightIcon"));
var _CaretDownIcon = _interopRequireDefault(require("../_icons/CaretDownIcon"));
var _translation = require("../_utils/translation");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _pageLabel, _mobilePageCountLabel;
  return {
    mainPaginationWrapper: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingTop: '20px',
      '& > p': {
        marginBottom: '1rem'
      }
    }, theme.breakpoints.up('md'), {
      paddingTop: '20px',
      flexDirection: 'row',
      paddingInline: '10px',
      '& > p': {
        marginBottom: 0
      }
    }),
    paginationContainer: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative'
    },
    pageLabel: (_pageLabel = {
      display: 'none',
      marginRight: theme.spacing(3),
      '&.open': {
        '& svg': {
          transform: 'rotate(180deg)',
          transition: 'all 0.25s ease-in-out'
        }
      }
    }, (0, _defineProperty2.default)(_pageLabel, theme.breakpoints.up('md'), {
      display: 'block'
    }), (0, _defineProperty2.default)(_pageLabel, '& span', {
      display: 'inline-block',
      marginRight: '10px',
      color: theme.palette.action.focus,
      fontWeight: 900,
      cursor: 'pointer',
      '& > svg': {
        marginLeft: '10px'
      }
    }), _pageLabel),
    dropdown: (0, _defineProperty2.default)({
      listStyle: 'outside none none',
      position: 'absolute',
      background: theme.palette.background.default,
      zIndex: 1,
      borderRadius: '4px',
      padding: 0,
      margin: '0',
      overflow: 'hidden',
      minWidth: '214px',
      maxHeight: '0',
      top: '50px',
      left: '0',
      transition: 'max-height 0.25s ease-in-out',
      '&.open': {
        border: "solid 1px ".concat(theme.palette.action.disabledBackground),
        maxHeight: '130px',
        overflow: 'hidden auto'
      },
      '& > li': {
        display: 'block',
        padding: '.75rem',
        background: theme.palette.background.default,
        cursor: 'pointer',
        '&:hover': {
          background: theme.palette.primary.light
        }
      }
    }, theme.breakpoints.up('md'), {
      display: 'block'
    }),
    buttonRoot: (0, _defineProperty2.default)({
      height: 44,
      width: 44
    }, theme.breakpoints.up('md'), {
      height: 32,
      width: 32
    }),
    buttonOutlined: {
      borderColor: theme.palette.grey[500],
      '&$buttonDisabled': {
        borderColor: theme.palette.grey[500]
      }
    },
    buttonDisabled: {},
    buttonIcon: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.primary.main
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(12)
    }),
    buttonIconDisabled: {
      color: theme.palette.grey[500]
    },
    mobilePageCountLabel: (_mobilePageCountLabel = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      border: "1px solid ".concat(theme.palette.grey[500]),
      padding: theme.spacing(0, 4),
      minWidth: '171px',
      marginInline: '12px !important',
      borderRightColor: "".concat(theme.palette.action.disabledBackground, " !important"),
      borderRadius: '5px !important'
    }, (0, _defineProperty2.default)(_mobilePageCountLabel, theme.breakpoints.up('md'), {
      display: 'none'
    }), (0, _defineProperty2.default)(_mobilePageCountLabel, '&.open', {
      '& svg': {
        transform: 'rotate(180deg)',
        transition: 'all 0.25s ease-in-out'
      }
    }), (0, _defineProperty2.default)(_mobilePageCountLabel, '& ul', {
      minWidth: '280px'
    }), _mobilePageCountLabel),
    mobileContainer: {
      display: 'inline-flex',
      '& $buttonRoot': {
        minWidth: 40,
        border: "1px solid ".concat(theme.palette.grey[500]),
        borderRadius: 5,
        '&:not(:first-child)': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        },
        '&:not(:last-child)': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  };
});
var PaginationWebinar = function PaginationWebinar(_ref) {
  var handleUpdatePage = _ref.handleUpdatePage,
    currentPage = _ref.currentPage,
    _ref$numPages = _ref.numPages,
    numPages = _ref$numPages === void 0 ? 0 : _ref$numPages,
    totalItems = _ref.totalItems,
    rangePerPage = _ref.rangePerPage,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      page: 'Page',
      pagination: 'Showing {pageStart} - {pageEnd} of {numberOfPages} Results'
    } : _ref$translations;
  var classes = useStyles();
  var firstPage = currentPage === 1;
  var lastPage = currentPage === numPages;
  var _useState = (0, _react.useState)(false),
    pageOpen = _useState[0],
    setPageOpen = _useState[1];
  var translationValues = {
    pageStart: rangePerPage.start + 1,
    pageEnd: rangePerPage.end,
    numberOfPages: totalItems
  };
  var theme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up('sm'), {
    defaultMatches: true
  });
  var changePage = function changePage(selectedPage) {
    handleUpdatePage(selectedPage);
    setPageOpen(false);
  };
  var pageLabel = (0, _translation.translate)(translations.pagination || '', translationValues);
  return __jsx("div", {
    className: classes.mainPaginationWrapper
  }, __jsx("p", null, pageLabel), __jsx("div", {
    className: classes.paginationContainer
  }, __jsx("div", {
    className: pageOpen ? "".concat(classes.pageLabel, " open") : "".concat(classes.pageLabel)
  }, __jsx("span", {
    onClick: function onClick() {
      return setPageOpen(!pageOpen);
    }
  }, translations.page, " ", currentPage, ' ', __jsx(_CaretDownIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon)
  })), ' ', "of ", numPages, __jsx("ul", {
    className: pageOpen ? "".concat(classes.dropdown, " open") : "".concat(classes.dropdown)
  }, Array(numPages).fill(0).map(function (_, i) {
    return __jsx("li", {
      key: "page".concat(i),
      onClick: function onClick() {
        return changePage(i + 1);
      }
    }, translations.page, " ", i + 1);
  }))), isDesktop ? __jsx(_core.ButtonGroup, {
    disableElevation: true,
    disableFocusRipple: true,
    disableRipple: true
  }, __jsx(_core.Button, {
    classes: {
      root: classes.buttonRoot,
      outlined: classes.buttonOutlined,
      disabled: classes.buttonDisabled
    },
    disabled: firstPage,
    onClick: function onClick() {
      return changePage(currentPage - 1);
    }
  }, __jsx(_CaretLeftIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, firstPage))
  })), __jsx(_core.Button, {
    classes: {
      root: classes.buttonRoot,
      outlined: classes.buttonOutlined,
      disabled: classes.buttonDisabled
    },
    disabled: lastPage,
    onClick: function onClick() {
      return changePage(currentPage + 1);
    }
  }, __jsx(_CaretRightIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, lastPage))
  }))) : __jsx("div", {
    className: classes.mobileContainer
  }, __jsx(_core.Button, {
    classes: {
      root: classes.buttonRoot,
      outlined: classes.buttonOutlined,
      disabled: classes.buttonDisabled
    },
    disabled: firstPage,
    onClick: function onClick() {
      return changePage(currentPage - 1);
    }
  }, __jsx(_CaretLeftIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, firstPage))
  })), __jsx("div", {
    className: pageOpen ? "".concat(classes.mobilePageCountLabel, " open") : "".concat(classes.mobilePageCountLabel),
    onClick: function onClick() {
      return setPageOpen(!pageOpen);
    }
  }, __jsx("div", null, __jsx("span", null, translations.page, " ", currentPage), "\xA0 of ", numPages), __jsx(_CaretDownIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon)
  }), __jsx("ul", {
    className: pageOpen ? "".concat(classes.dropdown, " open") : "".concat(classes.dropdown)
  }, Array(numPages).fill(0).map(function (_, i) {
    return __jsx("li", {
      key: "page".concat(i),
      onClick: function onClick() {
        return changePage(i + 1);
      }
    }, translations.page, " ", i + 1);
  }))), __jsx(_core.Button, {
    classes: {
      root: classes.buttonRoot,
      outlined: classes.buttonOutlined,
      disabled: classes.buttonDisabled
    },
    disabled: lastPage,
    onClick: function onClick() {
      return changePage(currentPage + 1);
    }
  }, __jsx(_CaretRightIcon.default, {
    className: (0, _clsx5.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, lastPage))
  })))));
};
var _default = PaginationWebinar;
exports.default = _default;